import type { SVGProps } from 'react';

const SvgAlignHorizontalLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M4 22H2V2h2zM22 7H6v3h16zm-6 7H6v3h10z" />
  </svg>
);
export default SvgAlignHorizontalLeft;
